import { AtDropdownProps } from "./at-dropdown.types";
import { TextField, MenuItem } from "@mui/material";
import { GlobalTextFieldStyles } from "../../../theme/global-styles";
export const AtDropdown = ({
  label,
  value,
  error,
  disabled,
  onChange,
  options,
  helpText,
  required,
}: AtDropdownProps) => {
  const onSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <>
      <GlobalTextFieldStyles />
      <TextField
        select
        disabled={disabled}
        error={error}
        label={label}
        value={value}
        onChange={onSelect}
        helperText={helpText}
        required={required}
        variant="outlined"
        fullWidth
        size="small"
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};
